"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var roundToDecimal = function roundToDecimal(x) {
  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var d = Math.pow(10, decimal);
  return Math.round(x * d) / d;
};

var _default = roundToDecimal;
exports["default"] = _default;